import type { BillingStatus } from '../../api/billing'

interface Props {
  billing: BillingStatus | null
}

export default function SubscriptionGraceBanner({ billing }: Props) {
  if (!billing?.show_grace_banner) return null
  const days = billing.grace_days_left ?? 0
  return (
    <div
      className="subscription-grace-banner"
      data-testid="subscription-grace-banner"
      role="status"
    >
      Add a payment method · {days} day{days === 1 ? '' : 's'} left
    </div>
  )
}
